let en = {

}

export default(en);



// WEBPACK FOOTER //
// ./src/lang/types/en.js